import { FC } from 'react';
import {
  Badge,
  Button,
  Icon,
  Popover,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
} from '@chakra-ui/react';
import { BiChevronDown, BiFilterAlt } from 'react-icons/bi';

type FilterMenuProps = PopoverProps & {
  label: string;
  numOfSelectedItems?: number;
};

export const FilterMenu: FC<FilterMenuProps> = ({
  label,
  children,
  numOfSelectedItems,
  ...props
}) => {
  return (
    <Popover placement="bottom-start" {...props}>
      <PopoverTrigger>
        <Button
          size="md"
          variant="outline"
          data-testid="filter-menu-btn"
          leftIcon={<Icon as={BiFilterAlt} fontSize="lg" />}
          rightIcon={<Icon as={BiChevronDown} fontSize="lg" />}
        >
          {label}
          {numOfSelectedItems ? (
            <Badge
              ml="2"
              variant="solid"
              colorScheme="blue"
              borderRadius="full"
              data-testid="selected-items-badge"
            >
              {numOfSelectedItems}
            </Badge>
          ) : null}
        </Button>
      </PopoverTrigger>
      <PopoverContent w="auto">{children}</PopoverContent>
    </Popover>
  );
};
